import styled from 'styled-components'

export const StyledSectionBuilder = styled.main`
  z-index: 1;
  position: relative;

  ${({ theme }) => theme.mediaQuery.md(`
    &::before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100%);
      background-color: white;
      border-bottom-left-radius: ${theme.rem(40)};
      border-bottom-right-radius: ${theme.rem(40)};
    }
  `)}

  &.privacy-policy{
    h4{
      line-height: 150%;
      margin-bottom: ${({ theme }) => theme.rem(10)};

      ${({ theme }) => theme.mediaQuery.md(`
        line-height: 130%;
      `)}
    }

    p{
      line-height: 160%;
    }
  }
`
